import React, { FC } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import { useTheme } from '@mui/material';
import { SettingsContext } from '../../provider/settings';

const AppThemeSwitcher: FC = () => {
	const theme = useTheme();

	const [isDarkMode, setIsDarkMode] = React.useState(theme.palette.mode === 'dark');

	const { setThemeMode } = React.useContext(SettingsContext);

	const handleChange = () => {
		const newThemeMode = isDarkMode ? 'light' : 'dark';

		setThemeMode(newThemeMode);

		window.localStorage.setItem('_app_theme', newThemeMode);

		setIsDarkMode((prev) => !prev);
	};

	return (
		<ToggleButton
			value="enable-dark-theme"
			aria-label="toggle dark theme"
			selected={isDarkMode}
			onChange={handleChange}
			style={{ border: 0 }}
		>
			<Brightness4Icon />
		</ToggleButton>
	);
};

export default AppThemeSwitcher;
